import { createSlice } from '@reduxjs/toolkit';
import * as actions from './actions';

const initialState = {
    companyShopMonitorIPsList: [],
    isShopMonitorIPsLoaded: false,
    isDeleteLoaded: false,
    isValidIpLoaded: false,
    isValidIp: false,

}

const companyShopMonitorIPsSlice = createSlice({
    name: 'CompanyShopMonitorIPs',
    initialState,
    reducers: {
        setScrollId(state, action) {
            state.scrollId = action.payload.scrollId;
        }
    },
    extraReducers: (builder) => {
        //getAllCompanyShopMonitorIPs
        builder.addCase(actions.getAllCompanyShopMonitorIPs.pending, (state) => {
            state.isShopMonitorIPsLoaded = false;
        })
        builder.addCase(actions.getAllCompanyShopMonitorIPs.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.companyShopMonitorIPsList = action.payload.data;
            } else {
                state.companyShopMonitorIPsList = [];
            }
            state.isShopMonitorIPsLoaded = true;
        })
        builder.addCase(actions.getAllCompanyShopMonitorIPs.rejected, (state) => {
            state.isShopMonitorIPsLoaded = false;
        });

        //delete 
        builder.addCase(actions.deleteCompanyShopMonitorIPs.pending, (state) => {
            state.isDeleteLoaded = true;
        })
        builder.addCase(actions.deleteCompanyShopMonitorIPs.fulfilled, (state, action) => {
            if (action.payload.success) {
                const id = action.payload.data;
                state.companyShopMonitorIPsList = state.companyShopMonitorIPsList.filter(item => item.id !== id);

            }
            state.isDeleteLoaded = false;
        })
        builder.addCase(actions.deleteCompanyShopMonitorIPs.rejected, (state) => {
            state.isDeleteLoaded = false;
        });

        // checkValidIpAddress
        builder.addCase(actions.checkValidIpAddress.pending, (state) => {
            state.isValidIpLoaded = false;
        });
        builder.addCase(actions.checkValidIpAddress.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.isValidIp = action.payload.data;
            } else {
                state.isValidIp = false;
            }
            state.isValidIpLoaded = true;
        });
        builder.addCase(actions.checkValidIpAddress.rejected, (state) => {
            state.isValidIp = false;
            state.isValidIpLoaded = true;
        });

    }
});

export const { setScrollId } = companyShopMonitorIPsSlice.actions

export default companyShopMonitorIPsSlice.reducer;